var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c("div", {
      staticClass: "ban",
      staticStyle: { "background-image": "url('/images/ban1.jpg')" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "wp" }, [
      _c("div", { staticClass: "g-top" }, [
        _c("div", { staticClass: "tab" }, [
          _c("ul", [
            _c("li", { class: { on: _vm.activeTab === "docs" } }, [
              _c(
                "a",
                {
                  attrs: { href: "/resource-center?type=docs" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setActiveTab("docs")
                    },
                  },
                },
                [_vm._v("技术文档")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: { on: _vm.activeTab === "specifications" } }, [
              _c(
                "a",
                {
                  attrs: { href: "/resource-center?type=specifications" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setActiveTab("specifications")
                    },
                  },
                },
                [_vm._v("产品说明")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: { on: _vm.activeTab === "manuals" } }, [
              _c(
                "a",
                {
                  attrs: { href: "/resource-center?type=manuals" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setActiveTab("manuals")
                    },
                  },
                },
                [_vm._v("产品手册")]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cur" }, [
          _vm._v("\n        当前位置：\n        "),
          _c("a", { attrs: { href: "/" } }, [_vm._v("首页")]),
          _vm._v(" >\n        "),
          _c("a", { attrs: { href: "/resource-center" } }, [
            _vm._v("资源中心"),
          ]),
          _vm._v(" >\n        "),
          _vm.activeTab === "docs"
            ? _c("span", [_vm._v("技术文档")])
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTab === "specifications"
            ? _c("span", [_vm._v("产品说明")])
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTab === "manuals"
            ? _c("span", [_vm._v("产品手册")])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wp" }, [
      _vm.activeTab === "docs" || _vm.activeTab === "manuals"
        ? _c(
            "ul",
            { staticClass: "m-list1" },
            _vm._l(_vm.resList, function (item, index) {
              return _c("li", { key: index }, [
                _c("h3", { staticClass: "tit" }, [
                  _c(
                    "a",
                    {
                      staticStyle: {
                        "background-image": "url('/images/i-21.png')",
                      },
                      attrs: {
                        href: item.pictureAlbumImgCn,
                        download: item.pictureAlbumNameCn,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.downloadFile(item.pictureAlbumImgCn)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.pictureAlbumNameCn))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    attrs: {
                      href: item.pictureAlbumImgCn,
                      download: item.pictureAlbumNameCn,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.downloadFile(item.pictureAlbumImgCn)
                      },
                    },
                  },
                  [_vm._v("下载")]
                ),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeTab === "specifications"
        ? _c(
            "ul",
            { staticClass: "m-list2" },
            _vm._l(_vm.resList, function (item, index) {
              return _c("li", { key: index }, [
                _c("div", { staticClass: "con" }, [
                  _c("h3", { staticClass: "tit" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: item.pictureAlbumImgCn,
                          download: item.pictureAlbumNameCn,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.downloadFile(item.pictureAlbumImgCn)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.pictureAlbumNameCn))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn",
                      attrs: {
                        href: item.pictureAlbumImgCn,
                        download: item.pictureAlbumNameCn,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.downloadFile(item.pictureAlbumImgCn)
                        },
                      },
                    },
                    [_vm._v("下载")]
                  ),
                ]),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pages" }, [_c("ul")])
  },
]
render._withStripped = true

export { render, staticRenderFns }